module.exports = __webpack_public_path__ + "img/catalyst_logo.8a5d8663.png";